import API from '../../../lib/commons/api'
import { APPLICATION_UUID } from '../../../lib/commons/appFunction'

export type ApplicationFunctionDto = {
  uuid: string
  externalId: string
  name: string
  hidden: boolean
  uiType: string
  displayOrder: number
  configurable: boolean
}

export type ApplicationDirectoryDto = {
  uuid: string
  externalId: string
  name: string
  displayOrder: number
  defaultOpen: boolean
  directories: ApplicationDirectoryDto[]
  functions: ApplicationFunctionDto[]
}

// TODO 判定条件を見直す（未使用の機能などを非表示とするために使用）
export const DEPRECATED_FUNCTION_DISPLAY_ORDER = 99

type GetAllFunctionsResponse = {
  directories: ApplicationDirectoryDto[]
}

export const getAllFunctions = async (): Promise<GetAllFunctionsResponse> => {
  const response = await API.functional.request(
    'GET',
    '/api/v1/functions/all',
    {
      applicationUuid: APPLICATION_UUID,
    }
  )
  return response.json as GetAllFunctionsResponse
}
